export enum PolicyType {
	TERMS_AND_CONDITIONS = "TERMS_AND_CONDITIONS",
	PRIVACY_POLICY = "PRIVACY_POLICY"
}

export enum PolicyTermType {
	PARAGRAPH = "paragraph",
	BULLETS = "bullets"
}

export type Section = {
	title: string;
	data: Subsection[];
};

export type Subsection = {
	subtitle: string;
	data: Term[];
};

export type Term = {
	type: PolicyTermType;
	data: string[] | string;
};
